import { IEcommerceQuestionSchema } from '../../types'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import { getMediumAssetPath } from '@aytm/lib/common/assets'
import { useBannerImpression } from '../../hooks/useBannerImpression'
import style from './PromoRow.module.scss'

const PromoRow = ({
  schema,
  onItemSelect
}: {
  schema: IEcommerceQuestionSchema
  onItemSelect: (index: number, bannerPlacement?: string) => void
}) => {
  const promoAnswers = schema.answers.filter(answer => answer.banner)
  if (promoAnswers.length === 0) return null
  const viewport = useViewport()
  const { t } = useSurveyLocale()

  // Get the index of the first promo product
  const promoProductIndex = promoAnswers[0]?.index
  const promoProductId = promoAnswers[0]?.id

  // Track banner impression
  const bannerRef = useBannerImpression(promoProductId, 'banner')

  const handleBannerClick = () => {
    if (promoProductIndex !== undefined) {
      onItemSelect(promoProductIndex, 'banner')
    }
  }

  return (
    <div className={style.promoContainer}>
      {/* Desktop: ad_image1 */}
      {!viewport.mobile && schema.ad_image1 && (
        <div ref={bannerRef} className={style.desktopBanner} onClick={handleBannerClick}>
          <img src={getMediumAssetPath(schema.ad_image1)} alt="Banner" className={style.bannerImage} />
          <div className={style.sponsoredLabel}>{t('questions', 'ec', 'target', 'sponsored')}</div>
        </div>
      )}

      {/* Mobile: ad_image2 */}
      {viewport.mobile && schema.ad_image2 && (
        <div ref={bannerRef} className={style.mobileBanner} onClick={handleBannerClick}>
          <img src={getMediumAssetPath(schema.ad_image2)} alt="Banner" className={style.bannerImage} />
          <div className={style.sponsoredLabel}>{t('questions', 'ec', 'target', 'sponsored')}</div>
        </div>
      )}
    </div>
  )
}

export default PromoRow
